/**
 * 延后加载 GA/gtag（在 app.vue 调用），避免首屏 head 内联脚本与 gtag.js 抢占主线程导致 LCP 渲染延迟。
 */
import { isGaEnabled } from '~/utils/analyticsEnv.js'
import { notifyGtagReady } from '~/utils/gaEcommerce.js'

export function useDeferredGtag() {
  const config = useRuntimeConfig()
  const gaId = config.public.gaMeasurementId || 'G-1B0SKSECQM'
  const gaOn = isGaEnabled(config) && Boolean(gaId)

  if (!import.meta.client || !gaOn) return

  const router = useRouter()

  function configure() {
    if (typeof window.gtag !== 'function') return
    window.gtag('config', gaId, { send_page_view: true })
    notifyGtagReady()
  }

  function inject() {
    if (document.querySelector('script[data-lip-gtag]')) {
      configure()
      return
    }

    const stub = document.createElement('script')
    stub.textContent =
      'window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag("js",new Date());'
    document.head.appendChild(stub)

    const ext = document.createElement('script')
    ext.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
    ext.async = true
    ext.dataset.lipGtag = '1'
    // config 完成后再放行排队中的电商事件，避免早于 measurement config
    ext.onload = () => configure()
    document.body.appendChild(ext)
  }

  const schedule = () => {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(inject, { timeout: 6000 })
    } else {
      setTimeout(inject, 2000)
    }
  }

  onMounted(() => {
    if (document.readyState === 'complete') {
      schedule()
    } else {
      window.addEventListener('load', schedule, { once: true, passive: true })
    }
  })

  let firstNavigation = true
  router.afterEach((to) => {
    if (firstNavigation) {
      firstNavigation = false
      return
    }
    configure()
  })
}
